export const profile = {
  name: 'Behnam Amiri',
  domain: 'bamiri.dev',
  promptUser: 'behnam',
  promptHost: 'bamiri.dev',
  role: 'AI Software Engineer',
  identity: 'Software builder',
  about: 'I turn ideas into real, working products.',
  email: 'behamiridev@gmail.com',
  focus: [
    'backend infrastructure',
    'deep learning',
    'distributed systems',
    'full-stack products',
    'machine learning systems'
  ],
  socialLinks: [
    { label: 'GitHub', href: 'https://github.com/BehnamAxo' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/behamiri' }
  ]
};
